import React from 'react';

class PlayersDropdownScoresheet extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			handicapStr: this.props.handicap.toString()
		};
	
		this.handlePlayerChange = this.handlePlayerChange.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnblur = this.handleOnblur.bind(this);
		this.createSelectItem = this.createSelectItem.bind(this);
	}

	handlePlayerChange(e) {
		var playerInfo = e.target.name.split(".");
		var teamNumber = playerInfo[1];
		var playerNumber = playerInfo[2];
		this.props.handlePlayerChange(e.target.value, teamNumber, playerNumber);
	}

	handleOnChange(e) {
		this.setState({handicapStr: e.target.value});
	}

	handleOnblur(e) {
		var newHandicap = 0.0;
		if (e.target.value !== "") {
			newHandicap = parseFloat(e.target.value);
		}

		if (isNaN(newHandicap) || (newHandicap < 0)) {
			newHandicap = 0;
		}

		var playerInfo = e.target.name.split(".");
		var teamNumber = playerInfo[1];
		var playerNumber = playerInfo[2];

		this.props.handleHandicapChange(newHandicap, teamNumber, playerNumber);

		// set input string
		this.setState({handicapStr: newHandicap.toString()});
	}

	render() {
		// console.log('PlayersDropdownScoresheet: render')
		return (
			<div className="row">
				<div className="col-md-8">
					 <select className="form-control" value={this.props.value} 
						onChange={this.handlePlayerChange} name={this.props.playerNumber}>
						{this.props.players.map(this.createSelectItem)}
						<option disabled>───── substituts ─────</option>
						{this.props.subPlayers.map(this.createSelectItem)}
					</select>
				</div>
				<div className="col-md-4">
					<input className="form-control" type="text" name={"h" + this.props.playerNumber} 
						value={this.state.handicapStr} onChange={this.handleOnChange} onBlur={this.handleOnblur} />
				</div>
			</div>
		);
	}

	createSelectItem(player, idx) {
		return (
			<option value={player.playerId} key={'pds'+ idx}> {player.name} </option>
		);
	}

}

export default PlayersDropdownScoresheet;

